module.exports = __webpack_public_path__ + "img/bxpfjrjn.5118a647.png";